const FILE_ICON_MAP: Record<string, string> = {
  // Documents
  pdf: '/icons/ic-pdf.svg',
  doc: '/icons/ic-word.svg',
  docx: '/icons/ic-word.svg',
  xls: '/icons/ic-excel.svg',
  xlsx: '/icons/ic-excel.svg',
  ppt: '/icons/ic-power-point.svg',
  pptx: '/icons/ic-power-point.svg',
  // Images
  jpg: '/icons/ic-img.svg',
  jpeg: '/icons/ic-img.svg',
  png: '/icons/ic-img.svg',
  gif: '/icons/ic-img.svg',
  webp: '/icons/ic-img.svg',
  svg: '/icons/ic-img.svg',
  bmp: '/icons/ic-img.svg',
  tiff: '/icons/ic-img.svg',
  tif: '/icons/ic-img.svg',
  heic: '/icons/ic-img.svg',
  // Video
  mp4: '/icons/ic-video.svg',
  mov: '/icons/ic-video.svg',
  avi: '/icons/ic-video.svg',
  mkv: '/icons/ic-video.svg',
  webm: '/icons/ic-video.svg',
  wmv: '/icons/ic-video.svg',
  // Audio
  mp3: '/icons/ic-audio.svg',
  wav: '/icons/ic-audio.svg',
  ogg: '/icons/ic-audio.svg',
  m4a: '/icons/ic-audio.svg',
  aac: '/icons/ic-audio.svg',
  flac: '/icons/ic-audio.svg',
  // Archives
  zip: '/icons/ic-zip.svg',
  rar: '/icons/ic-zip.svg',
  '7z': '/icons/ic-zip.svg',
  tar: '/icons/ic-zip.svg',
  gz: '/icons/ic-zip.svg',
};

const DEFAULT_FILE_ICON = '/icons/ic-file.svg';

export const getFileIcon = (filename: string): string => {
  const extension = filename.toLowerCase().split('.').pop() || '';
  return FILE_ICON_MAP[extension] || DEFAULT_FILE_ICON;
};
